import React, { useEffect, useState } from "react"
import { SaveButton } from "components/Buttons"
import { Col, Nav, NavLink, Row, TabContent, TabPane } from "reactstrap"
import ProductTypeTab from "./productTypeTab"
import ProductInfoTab from "./productInfoTab"
import AccessTab from "./accessTab"
import ConfirmationMessageTab from "./confirmationMessageTab"
import { connect } from "react-redux"
import {
  Field,
  FormSection,
  formValueSelector,
  getFormSyncErrors,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import BottomNavigation from "components/BottomNavigation"
import {
  createProduct,
  getBusinessUnits,
  getMetaTags,
  getProducts,
  getStripeProducts,
  resetFeatureRecipients,
  resetProduct,
  updateProduct,
} from "store/actions"
import { SingleSelectField } from "components/RenderInput"
import validate from "./productFormValidation"
import PayoutsTab from "./payoutsTab"

const ProductForm = ({
  handleBack,
  businessUnits,
  getBusinessUnits,
  getStripeProducts,
  getMetaTags,
  handleSubmit,
  createProduct,
  vendorId,
  getProducts,
  selectedProduct,
  resetProduct,
  initializeForm,
  resetFeatureRecipients,
  featureRecipients,
  categoryId,
  updateProduct,
  productType,
  businessUnit,
  formSyncErrors,
  setSubTabBreadcrumb,
}) => {
  const TABS = {
    TYPE: 1,
    INFO: 2,
    ACCESS: 3,
    CONFIRMATION_MESSAGE: 4,
    PAYOUTS: 5,
  }

  const [activeTab, setActiveTab] = useState(TABS.TYPE)

  useEffect(() => {
    if (selectedProduct && !!selectedProduct?.tp_product_event_date_id) {
      setActiveTab(TABS.INFO)
    }
  }, [selectedProduct])

  useEffect(() => {
    const items = [
      {
        title: selectedProduct ? "Edit Product" : "Create Product",
        type: "tab",
        clickHandler: () => {
          setActiveTab(TABS.TYPE)
        },
      },
    ]
    switch (activeTab) {
      case 1:
        items.push({ title: "Product Type" })
        break
      case 2:
        items.push({
          title: "Product Info",
        })
        break
      case 3:
        items.push({ title: "Access" })
        break
      case 4:
        items.push({ title: "Confirmation Message" })
        break
      case 5:
        items.push({ title: "Payouts" })
        break
      default:
        break
    }
    setSubTabBreadcrumb(items)
  }, [activeTab, selectedProduct])

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    getBusinessUnits()
    getStripeProducts()
    return () => {
      resetProduct()
      resetFeatureRecipients()
      getProducts({ o: "name", od: "asc" })
    }
  }, [])

  useEffect(() => {
    if (!businessUnit) {
      getMetaTags({ hide_for_business_unit: 1 })
    } else {
      getMetaTags({ business_unit_id: businessUnit })
    }
  }, [businessUnit])

  useEffect(() => {
    if (selectedProduct) {
      initializeForm({
        type: {
          productType: !selectedProduct?.stripe_product_id ? "1" : "2",
        },
        info: {
          stripeProduct: selectedProduct?.stripe_product_id,
          stripePrice: selectedProduct?.stripe_price_id,
          name: selectedProduct?.name,
          price: selectedProduct?.price,
        },
        access: {
          adminTags: selectedProduct?.tag_ids
            ? selectedProduct?.tag_ids
            : selectedProduct?.tags?.map(tag => tag?.id),
          tagExpireNumber: selectedProduct?.tag_expire_number || 0,
          tagExpireType: selectedProduct?.tag_expire_type,
          userTags: selectedProduct?.user_tag_ids
            ? selectedProduct?.user_tag_ids
            : selectedProduct?.user_tags?.map(tag => tag?.id),
          selectOne: selectedProduct?.restrict_one_user_tag,
          userTagLabel: selectedProduct?.user_tags_label,
          accessTags: selectedProduct?.access_tags?.map(tag => tag?.id),
          removeTags: selectedProduct?.remove_tags?.map(tag => tag?.id),
        },
        confirmationMessage: {
          selectedAdmins: featureRecipients?.map(user => ({
            label: user?.label
              ? user?.label
              : `${user?.first_name} ${user?.last_name} (${user?.email})`,
            value: user?.value ? user?.value : user?.id,
          })),
          confirmationMessage: selectedProduct?.email_content,
        },
        businessUnit: selectedProduct?.business_unit_id,
      })
    }
  }, [selectedProduct, featureRecipients])

  const handleSave = data => {
    if (selectedProduct) {
      updateProduct({
        values: {
          ...selectedProduct,
          business_unit_id: data?.businessUnit,
          email_content: data?.confirmationMessage?.confirmationMessage,
          name: data?.info?.name,
          price: data?.info?.price,
          restrict_one_user_tag: data?.access?.selectOne ? 1 : 0,
          stripe_price_id: data?.info?.stripePrice,
          stripe_product_id: data?.info?.stripeProduct,
          tag_expire_number: data?.access?.tagExpireNumber,
          tag_expire_type: data?.access?.tagExpireType,
          tag_ids: data?.access?.adminTags || [],
          user_tag_ids: data?.access?.userTags || [],
          user_tags_label: data?.access?.userTagLabel,
          access_tag_ids: data?.access?.accessTags || [],
          access_tags: data?.access?.accessTags || [],
          remove_tags: data?.access?.removeTags || [],
          remove_tag_ids: data?.access?.removeTags || [],
        },
        user_ids: data?.confirmationMessage?.selectedAdmins,
      })
    } else {
      createProduct({
        values: {
          business_unit_id: data?.businessUnit,
          category_id: categoryId || null,
          email_content: data?.confirmationMessage?.confirmationMessage,
          name: data?.info?.name,
          price: data?.info?.price,
          restrict_one_user_tag: data?.access?.selectOne ? 1 : 0,
          stripe_price_id: data?.info?.stripePrice,
          stripe_product_id: data?.info?.stripeProduct,
          tag_expire_number: data?.access?.tagExpireNumber,
          tag_expire_type: data?.access?.tagExpireType,
          tag_ids: data?.access?.adminTags || [],
          tags: data?.access?.adminTags || [],
          type: data?.type?.productType,
          user_tag_ids: data?.access?.userTags || [],
          user_tags: data?.access?.userTags || [],
          vendor_id: vendorId,
          user_tags_label: data?.access?.userTagLabel,
          access_tag_ids: data?.access?.accessTags || [],
          access_tags: data?.access?.accessTags || [],
          remove_tags: data?.access?.removeTags || [],
          remove_tag_ids: data?.access?.removeTags || [],
        },
        user_ids: data?.confirmationMessage?.selectedAdmins,
        // callback: () => {
        //   getProducts({ o: "name", od: "asc" })
        //   handleBack()
        // },
      })
    }
  }

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-between">
        <Col xs="auto" className="ms-5">
          {selectedProduct && (
            <>
              <h5 className="mt-1">Edit Product: {selectedProduct?.name}</h5>
              {!!selectedProduct?.tp_product_event_date_id && (
                <span>
                  This is a product created based on TP data, you can only
                  update specific information as the main data comes from TP.
                </span>
              )}
            </>
          )}
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Done"
            color="light"
            onClick={handleBack}
          />
        </Col>
      </Row>
      {businessUnits?.length > 0 && (
        <Row className="mb-3">
          <Col xs="auto" className="ms-5 mt-2">
            <label>Business Unit:</label>
          </Col>
          <Col xs="auto">
            <div style={{ width: "280px" }}>
              <Field
                name="businessUnit"
                component={SingleSelectField}
                placeholder="No Business Unit"
                options={[
                  { value: null, label: "No Business Unit" },
                  ...businessUnits?.map(bu => ({
                    value: bu?.id,
                    label: bu?.name,
                  })),
                ]}
              />
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col xs="auto" className="ms-5">
          <Nav pills className="flex-column">
            {!selectedProduct?.tp_product_event_date_id && (
              <NavLink
                className={markIfIsActive(TABS.TYPE)}
                onClick={() => setActiveTab(TABS.TYPE)}
                style={
                  activeTab === TABS.TYPE ? {} : { backgroundColor: "#eff2f7" }
                }
              >
                {<span style={{ fontSize: "16px" }}>Product Type</span>}
              </NavLink>
            )}
            <NavLink
              className={markIfIsActive(TABS.INFO)}
              onClick={() => setActiveTab(TABS.INFO)}
              style={
                activeTab === TABS.INFO ? {} : { backgroundColor: "#eff2f7" }
              }
            >
              {
                <span style={{ fontSize: "16px" }}>
                  {selectedProduct &&
                  !!selectedProduct?.tp_product_event_date_id
                    ? "Product Info"
                    : parseInt(productType) === 1
                    ? "Create Product"
                    : "Select Product"}
                </span>
              }
            </NavLink>
            <NavLink
              className={markIfIsActive(TABS.ACCESS)}
              onClick={() => setActiveTab(TABS.ACCESS)}
              style={
                activeTab === TABS.ACCESS ? {} : { backgroundColor: "#eff2f7" }
              }
            >
              {<span style={{ fontSize: "16px" }}>Access</span>}
            </NavLink>
            {!selectedProduct?.tp_product_event_date_id && (
              <NavLink
                className={markIfIsActive(TABS.CONFIRMATION_MESSAGE)}
                onClick={() => setActiveTab(TABS.CONFIRMATION_MESSAGE)}
                style={
                  activeTab === TABS.CONFIRMATION_MESSAGE
                    ? {}
                    : { backgroundColor: "#eff2f7" }
                }
              >
                {<span style={{ fontSize: "16px" }}>Confirmation Message</span>}
              </NavLink>
            )}
            {/* {selectedProduct && (
              <NavLink
                className={markIfIsActive(TABS.PAYOUTS)}
                onClick={() => setActiveTab(TABS.PAYOUTS)}
                style={
                  activeTab === TABS.PAYOUTS
                    ? {}
                    : { backgroundColor: "#eff2f7" }
                }
              >
                {<span style={{ fontSize: "16px" }}>Payouts</span>}
              </NavLink>
            )} */}
          </Nav>
        </Col>
        <Col>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={TABS.TYPE}>
              <FormSection name="type">
                <ProductTypeTab />
              </FormSection>
              <BottomNavigation handleNext={() => setActiveTab(TABS.INFO)} />
            </TabPane>
            <TabPane tabId={TABS.INFO}>
              <FormSection name="info">
                <ProductInfoTab
                  tabIsActive={activeTab === TABS.INFO}
                  handleSave={handleSubmit(handleSave)}
                  isTPProduct={!!selectedProduct?.tp_product_event_date_id}
                />
              </FormSection>
              <BottomNavigation
                handleBack={
                  selectedProduct && !!selectedProduct?.tp_product_event_date_id
                    ? null
                    : () => setActiveTab(TABS.TYPE)
                }
                handleNext={() => setActiveTab(TABS.ACCESS)}
                handleSave={handleSubmit(handleSave)}
                // saveButtonDisabled={
                //   !formSyncErrors || Object?.keys(formSyncErrors)?.length !== 0
                // }
              />
            </TabPane>
            <TabPane tabId={TABS.ACCESS}>
              <FormSection name="access">
                <AccessTab
                  tabIsActive={activeTab === TABS.ACCESS}
                  handleSave={handleSubmit(handleSave)}
                  isTPProduct={!!selectedProduct?.tp_product_event_date_id}
                />
              </FormSection>
              <BottomNavigation
                handleBack={() => setActiveTab(TABS.INFO)}
                handleNext={() =>
                  setActiveTab(
                    selectedProduct &&
                      !!selectedProduct?.tp_product_event_date_id
                      ? TABS.PAYOUTS
                      : TABS.CONFIRMATION_MESSAGE
                  )
                }
                handleSave={handleSubmit(handleSave)}
                // saveButtonDisabled={
                //   !formSyncErrors || Object?.keys(formSyncErrors)?.length !== 0
                // }
              />
            </TabPane>
            <TabPane tabId={TABS.CONFIRMATION_MESSAGE}>
              <FormSection name="confirmationMessage">
                <ConfirmationMessageTab
                  tabIsActive={activeTab === TABS.CONFIRMATION_MESSAGE}
                  handleSave={handleSubmit(handleSave)}
                />
              </FormSection>
              <BottomNavigation
                handleBack={() => setActiveTab(TABS.ACCESS)}
                // handleNext={
                //   selectedProduct ? () => setActiveTab(TABS.PAYOUTS) : null
                // }
                handleSave={handleSubmit(handleSave)}
                // saveButtonDisabled={
                //   !formSyncErrors || Object?.keys(formSyncErrors)?.length !== 0
                // }
              />
            </TabPane>
            {/* <TabPane tabId={TABS.PAYOUTS}>
              <PayoutsTab
                tabIsActive={activeTab === TABS.PAYOUTS}
                handleSave={handleSubmit(handleSave)}
              />
              <BottomNavigation
                handleBack={() =>
                  setActiveTab(
                    selectedProduct &&
                      !!selectedProduct?.tp_product_event_date_id
                      ? TABS.ACCESS
                      : TABS.CONFIRMATION_MESSAGE
                  )
                }
                // handleSave={handleSubmit(handleSave)}
                // saveButtonDisabled={
                //   !formSyncErrors || Object?.keys(formSyncErrors)?.length !== 0
                // }
              />
            </TabPane> */}
          </TabContent>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PRODUCT)

const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits,
  vendorId: state.Login.vendorId,
  selectedProduct: state.ProductsAndSubscriptions.selectedProduct,
  featureRecipients: state.ProductsAndSubscriptions.featureRecipients,
  productType: selector(state, "type.productType"),
  businessUnit: selector(state, "businessUnit"),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.PRODUCT)(state),
})

const mapDispatchToProps = dispatch => ({
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getStripeProducts: values => dispatch(getStripeProducts(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  createProduct: values => dispatch(createProduct(values)),
  getProducts: values => dispatch(getProducts(values)),
  resetProduct: () => dispatch(resetProduct()),
  initializeForm: values => dispatch(initialize(FORM_NAMES.PRODUCT, values)),
  resetFeatureRecipients: () => dispatch(resetFeatureRecipients()),
  updateProduct: values => dispatch(updateProduct(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.PRODUCT,
    initialValues: {
      type: {
        productType: "2",
      },
      access: {
        tagExpireNumber: 0,
      },
    },
    validate,
  })(ProductForm)
)
